import React, { useEffect, useState } from "react";
import { Card, Row, Col, Avatar, List, Typography, Tag } from "antd";
import {
  TrophyOutlined,
  StarOutlined,
  BookOutlined,
  CheckCircleOutlined,
  CrownOutlined,
  ReadOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { LEARNER_LEADERBOARD_VIEW } from "../../apis/apis";
const { Title, Text } = Typography;

function Leaderboard() {
  const [learners, setLearners] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const gradients = [
    "linear-gradient(135deg, rgba(209, 166, 46, 0.15), rgba(182, 238, 238, 0.15))",
    "linear-gradient(135deg, rgba(255,77,79,0.15), rgba(226, 190, 116, 0.15))",
    "linear-gradient(135deg, rgba(82,196,26,0.15), rgba(129, 181, 230, 0.15))",
  ];

  // ✅ API CALL (same pattern as your LIST_API)
  const LEADERBOARD_API = async () => {
    setLoading(true);

    const FORM_DATA = new FormData();

    try {
      const API_CALL = await LEARNER_LEADERBOARD_VIEW(FORM_DATA);

      if (API_CALL?.data?.status) {
        const apiData = API_CALL.data.data;
        const current = API_CALL.data.current_user;

        const mapped = apiData.map((item) => ({
          name: [item.first_name, item.last_name]
            .filter((val) => val && val !== "null")
            .join(" ")
            .trim(),
          courses: item.courses_completed,
          quizzes: item.quizzes_passed,
          points: item.total_points,
          rank: item.rank,
          color:
            item.rank === 1
              ? "#fadb14"
              : item.rank === 2
                ? "#d9d9d9"
                : item.rank === 3
                  ? "#fa8c16"
                  : "#bfbfbf",
          isCurrentUser: item.learner_id === current?.learner_id,
        }));

        setLearners(mapped);
        setCurrentUser(current);
      } else {
        console.log("Leaderboard API error");
      }
    } catch (error) {
      console.log("API Error:", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    LEADERBOARD_API();
  }, []);

  return (
    <div className="lms-body">
      <Card>
        <h2 style={{ margin: "0", padding: "0" }}>Leaderboard</h2>
        <Text type="secondary">See how you rank among other learners</Text>

        <Row gutter={20} style={{ marginTop: 20 }}>
          {/* LEFT SIDE */}
          <Col xs={24} lg={16}>
            <Card
              style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", borderRadius: 12 }}
              title={
                <>
                  <TrophyOutlined style={{ marginRight: 8, color: "orange" }} />
                  Top Learners
                </>
              }
            >
              <List
                loading={loading}
                itemLayout="horizontal"
                dataSource={learners}
                renderItem={(item, index) => (
                  <List.Item
                    style={{
                      background: item.isCurrentUser
                        ? "linear-gradient(135deg, rgba(114, 46, 209, 0.12), rgba(0, 242, 254, 0.12))"
                        : gradients[index % gradients.length],
                      borderRadius: "12px",
                      marginBottom: "12px",
                      padding: "16px 18px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* Rank Badge */}
                      <div
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background:
                            item.rank === 1
                              ? "#fff7e6"
                              : item.rank === 2
                                ? "#f5f5f5"
                                : item.rank === 3
                                  ? "#fff2e8"
                                  : "",
                          fontWeight: "bold",
                          marginRight: 14,
                        }}
                      >
                        {item.rank === 1 ? (
                          <div
                            style={{
                              backgroundColor: "gold",
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CrownOutlined style={{ color: "#fff", fontSize: 16 }} />
                          </div>
                        ) : item.rank === 2 ? (
                          <div
                            style={{
                              backgroundColor: "#bfbfbf",
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TrophyOutlined style={{ color: "#fff", fontSize: 16 }} /> </div>
                        ) : item.rank === 3 ? (
                          <div
                            style={{
                              backgroundColor: "#bb680e",
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TrophyOutlined style={{ color: "#fff", fontSize: 16 }} /> </div>
                        ) : (
                          item.rank
                        )}
                      </div>

                      {/* Avatar */}
                      <Avatar
                        style={{
                          backgroundColor: "#722ed1",
                          marginRight: 14,
                        }}
                      >
                        {item.name.charAt(0)}
                      </Avatar>

                      {/* Name + Details */}
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 15 }}>
                          {item.name}{" "}
                          {item.isCurrentUser && <Tag color="blue">You</Tag>}
                        </div>

                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                          <BookOutlined /> {item.courses} courses &nbsp;&nbsp;
                          <CheckCircleOutlined /> {item.quizzes} quizzes
                        </div>
                      </div>

                      {/* Points */}
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontWeight: 700, fontSize: 16, color: "#722ed1" }}>
                          {item.points}
                        </div>
                        <div style={{ fontSize: 12, color: "#8c8c8c" }}>points</div>
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </Card>
          </Col>

          {/* RIGHT SIDE */}
          <Col xs={24} lg={8}>
            {currentUser && (
              <Card style={{ borderRadius: 12, marginBottom: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
              >
                {/* Gradient Header */}
                <div
                  style={{
                    background: "linear-gradient(90deg, #722ed1, #00f2fe)",
                    padding: "16px",
                    color: "#fff",
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                  }}
                >
                  <Text style={{ color: "#fff" }}>Your Rank</Text>
                  <Title style={{ color: "#fff", margin: 0 }}>
                    {currentUser.rank}
                  </Title>
                </div>

                {/* Content */}
                <div style={{ padding: 16 }}>
                  <Row gutter={[16, 16]}>

                    <Col xs={24} sm={12}>
                      <Card
                        style={{ textAlign: "center", borderRadius: 12 }}
                        bodyStyle={{ padding: 20 }}
                      >
                        <StarOutlined style={{ fontSize: 28, color: "#faad14" }} />
                        <h2 style={{ margin: "10px 0 0" }}>{currentUser.total_points}</h2>
                        <div style={{ color: "#888" }}>Total Points</div>
                      </Card>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Card
                        style={{ textAlign: "center", borderRadius: 12 }}
                        bodyStyle={{ padding: 20 }}
                      >
                        <BookOutlined style={{ fontSize: 28, color: "#1677ff" }} />
                        <h2 style={{ margin: "10px 0 0" }}>{currentUser.courses_completed}</h2>
                        <div style={{ color: "#888" }}>Courses</div>
                      </Card>
                    </Col>

                    <Col xs={24}>
                      <Card
                        style={{ textAlign: "center", borderRadius: 12 }}
                        bodyStyle={{ padding: 20 }}
                      >
                        <CheckCircleOutlined style={{ fontSize: 28, color: "#52c41a" }} />
                        <h2 style={{ margin: "10px 0 0" }}>{currentUser.quizzes_passed}</h2>
                        <div style={{ color: "#888" }}>Quizzes Passed</div>
                      </Card>
                    </Col>

                  </Row>
                </div>
              </Card>
            )}

            <Card
              title="How to Earn Points"
              style={{
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: "12px",
              }}
            >
              <div>
                <p >
                  <Tag style={{ padding: "8px 10px", borderRadius: "50%", color: "#722ed1", backgroundColor: "rgba(114, 46, 209, 0.15)" }}>
                    <ReadOutlined />
                  </Tag>
                  Complete a Course
                </p>
                <span style={{ color: "gray", fontSize: "14px", marginLeft: "30px" }}>+100 points</span>
              </div>

              <div>
                <p style={{ marginTop: "8px" }}>
                  <Tag style={{ padding: "8px 10px", borderRadius: "50%", color: "#52c41a", backgroundColor: "rgba(82, 196, 26, 0.15)" }}>
                    <CheckOutlined />
                  </Tag>
                  Pass a Quiz
                </p>
                <span style={{ color: "gray", fontSize: "14px", marginLeft: "30px" }}>+20 points</span>
              </div>

              <div>
                <p style={{ marginTop: "8px" }}>
                  <Tag color="gold" style={{ padding: " 8px 10px", borderRadius: "50%" }}>
                    <StarOutlined />
                  </Tag>
                  Perfect Score
                </p>
                <span style={{ color: "gray", fontSize: "14px", marginLeft: "30px" }}>+10 points</span>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default Leaderboard;